import events from '@/services/events';
import store from '@/store';

export default function routerBeforeEach(to, from, next) {
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth);
  const { isSignedIn } = store.state.session;

  store.dispatch('session/captureCampaignId', { route: to });

  if (requiresAuth && !isSignedIn) {
    store.commit('session/SET_SIGN_IN_REDIRECT_ROUTE', to);

    next({
      name: 'signIn',
      params: { merchantId: to.params.merchantId }
    });
  }

  else {
    store.commit('session/SET_INITIAL_PAGE_LOAD', !from.name);

    const routeParentNamespace = to.matched?.[0]?.name;
    store.dispatch('session/setApplicationFlowFromRoute', routeParentNamespace);

    store.dispatch('session/updateRouteParams', { route: to });

    events.emit('route', { to, from });

    next();
  }
}
